import { createContext, useState } from 'react';

export interface CheckboxGroupCtxContextProps {
  checkboxGroupCtx: string;
  setCheckboxCtxGroup: (option: any) => void;
}

export const CheckboxGroupContext = createContext<CheckboxGroupCtxContextProps>({
  checkboxGroupCtx: '',
  setCheckboxCtxGroup: () => { }
})

export function CheckboxGroupProvider(props: { children: React.ReactNode }) {
  const [checkboxGroupCtx, setCheckboxCtxGroup] = useState<string>('');

  return (
    <CheckboxGroupContext.Provider value={{ checkboxGroupCtx, setCheckboxCtxGroup }}>
      {props.children}
    </CheckboxGroupContext.Provider>
  )
}